// NOTE: DO NOT UPDATE THIS RESERVED TRANSLATION KEYS AND THEIR VALUES
const reservedTranslationsWithUniqueKeyNames = {
  leadingSpaceNotAllowed: 'Spasi di awal tidak diperbolehkan.',
  trailingSpaceNotAllowed: 'Spasi di akhir tidak diperbolehkan.',
  mustbeAtleastCharacters: '{{label}} harus minimal {{minNumber}} karakter',
  cannotExceedCharacters: '{{label}} tidak boleh melebihi {{maxNumber}} karakter',
  numberMustbeAtleast: '{{label}} harus minimal bernilai {{minNumber}}',
  numberCannotExceed: '{{label}} tidak boleh melebihi {{maxNumber}}',
  isRequired: '{{label}} wajib diisi',
  emptySpaceNotContain: 'Kolom ini tidak boleh berisi spasi',
  noData: 'Tidak ada data tersedia.',
  404: '404',
  register: 'Daftar',
  login: 'Masuk',
  comingSoon: 'Segera Hadir',
  submit: 'Kirim',
  email: 'Email',
  termsConditions: 'Syarat & Ketentuan',
  password: 'Kata Sandi',
  eighteenPlus: 'Saya berusia di atas 18 tahun dan saya menyetujui Ketentuan Layanan',
  signUp: 'Daftar',
  createNewAccount: 'Buat Akun Baru',
  fullName: 'Nama Lengkap',
  referralCode: 'Kode Referral',
  confirmPassword: 'Konfirmasi Kata Sandi',
  facebook: ' Facebook',
  google: 'Google',
  haveAnAccount: 'Sudah punya akun? ',
  pageNotFound: 'Kami tidak dapat menemukan halaman yang Anda cari!',
  error: 'Kesalahan',
  somethingWentWrong: 'Terjadi kesalahan!',
  personalDetails: 'Detail Pribadi',
  firstName: 'Nama Depan',
  lastName: 'Nama Belakang',
  dateOfBirth: 'Tanggal lahir',
  phoneNumber: 'Nomor Telepon',
  change: 'Ubah',
  saveChanges: 'Simpan Perubahan',
  currentPassword: 'Kata Sandi Saat Ini',
  newPassword: 'Kata Sandi Baru',
  myProfile: 'Profil Saya',
  transactions: 'Transaksi',
  deposit: 'Setor',
  withdraw: 'Tarik',
  referral: 'Referral',
  changePassword: 'Ubah Kata Sandi',
  logout: 'Keluar',
  currency: 'Mata Uang.',
  view: 'Lihat',
  ok: 'Oke',
  cancel: 'Batal',
  userName: 'Nama Pengguna',
  passwordRegexMatch: 'Kata sandi harus mengandung satu huruf besar, satu angka dan satu karakter khusus',
  invalidEmailFormat: 'Format email tidak valid',
  noRecordsFound: 'Tidak Ada Catatan Ditemukan',
  backToLobby: 'Kembali ke lobi',
  noPlacedBet: 'Tidak ada Taruhan yang dipasang'
}

// NOTE: PLEASE ADD YOUR API SUCCESS MESSAGE TRANSLATIONS HERE ONLY
const apiSuccessMessagesTranslations = {
  loginSuccessfully: 'Berhasil masuk.',
  logoutSuccessfully: 'Berhasil keluar.',
  passwordUpdateSuccessfully: 'Kata sandi berhasil diperbarui.',
  updatePlayerStatusSuccessfully: 'Status pemain berhasil diperbarui.',
  resetPasswordSuccessfully: 'Kata sandi berhasil diatur ulang.',
  signupSuccessfully: 'Pendaftaran berhasil.',
  betPlacedSuccessfully: 'Taruhan berhasil dipasang.',
  betCancelledSuccessfully: 'Taruhan berhasil dibatalkan.',
  AUTO_BET_STARTED: 'Taruhan otomatis dimulai',
  AUTO_BET_FINISHED: 'Taruhan otomatis selesai',
  AUTO_BET_STOPPED: 'Taruhan otomatis dihentikan',
  PLEASE_SELECT_AT_LEAST_ONE_NUMBER: 'Silakan pilih setidaknya satu angka',
  PLEASE_WAIT_FOR_THE_GAME_TO_LOAD: 'Harap tunggu hingga permainan selesai dimuat!',
  YOU_ALREADY_HAVE_AN_OPEN_BET: 'Anda sudah memiliki taruhan yang masih aktif',
  YOU_ALREADY_HAVE_A_BET_PLACED: 'Anda sudah memasang taruhan.',
}

// NOTE: PLEASE ADD YOUR API ERROR MESSAGE TRANSLATIONS HERE ONLY
const apiErrorMessagesTranslations = {
  UnAuthorized: 'Sesi Anda telah berakhir',
  LoginFailedError: 'Gagal Masuk',
  InvalidCredentialsError: 'Kredensial Tidak Valid',
  InvalidTokenError: ' Token tidak valid',
  InvalidSessionError: ' Sesi kedaluwarsa',
  CreateUserError: 'Pengguna tidak dapat dibuat',
  DataMismatchError: 'Data tidak cocok',
  UserNotFoundError: 'Pengguna tidak ditemukan',
  DuplicateEmailError: 'Email sudah terdaftar',
  RequestInputValidationError: 'Silakan periksa data permintaan',
  ResponseInputValidationError: 'Validasi respons gagal, silakan lihat skema JSON dari respons',
  SocketRequestInputValidationError: 'Silakan periksa data permintaan untuk komunikasi socket',
  SocketResponseValidationError: 'Validasi respons komunikasi socket gagal, silakan lihat skema JSON dari respons',
  InternalServerError: 'Kesalahan Server Internal',
  InvalidSocketArgumentError: 'Silakan berikan argumen yang benar: eventName, [payloadObject], dan [callback]',
  InvalidCredentials: 'Kredensial tidak cocok',
  InvalidToken: 'Token akses tidak diberikan atau telah kedaluwarsa',
  InvalidSession: 'Sesi pengguna tidak valid, silakan masuk kembali',
  InvalidAccess: 'Izin ditolak',
  NonOperationalError: 'Terjadi kesalahan pada server',
  UserNotExists: 'Pengguna tidak ada',
  InvalidAction: 'Tindakan tidak valid',
  SessionAlreadyStarted: 'Sesi sudah dimulai',
  SessionNotStarted: 'Sesi belum dimulai',
  EmailNotVerified: 'Email belum terverifikasi',
  InvalidGameTypeError: 'Tidak ada pengaturan ditemukan untuk jenis permainan yang diberikan',
  InvalidGameRoundError: 'Tidak ada permainan ditemukan untuk detail permainan yang diberikan',
  NoRoundRunningError: 'Tidak ada ronde yang sedang berjalan saat ini',
  NoPlacedBetFoundError: 'Tidak ada taruhan yang dipasang ditemukan',
  NoWalletFoundError: 'Dompet tidak ditemukan dengan data yang ditentukan',
  NotEnoughBalanceError: 'Saldo tidak cukup untuk melakukan proses',
  AutoRateIsInvalidError: 'Rate Otomatis tidak dalam batas yang valid',
  BetAmountIsNotInLimitError: 'Jumlah Taruhan tidak dalam batas yang valid',
  EmailNotFound: 'Email tidak ditemukan',
  UserNotAbove18YearsError: 'Pengguna tidak berusia di atas 18 tahun',
  InvalidBlockchainAddress: 'Alamat Blockchain Tidak Valid',
  AddressMismatch: 'Alamat yang Diberikan dan Alamat yang Dipulihkan Tidak Cocok',
  NonceLifetimeExpired: 'Masa Berlaku Nonce Telah Berakhir',
  SomethingWentWrong: 'Terjadi Kesalahan',
  AccountNotActive: 'Akun tidak aktif',
  LoginTokenRequire: 'OTP (Kata Sandi Sekali Pakai) diperlukan',
  UserAlreadyExists: 'Pengguna sudah ada',
  InvalidVerificationToken: 'Token verifikasi tidak valid',
  UserNotActive: 'Pengguna diblokir, silakan hubungi admin',
  FileUploadFailed: 'Unggah gambar gagal',
  EmailAlreadyVerified: 'Email sudah terverifikasi',
  InvalidReferralCode: 'Kode Referral Tidak Valid',
  InvalidAffiliateCode: 'Kode Afiliasi Tidak Valid',
  RecordNotFound: 'Catatan Tidak Ditemukan',
  WithdrawalRequestAlreadyPending: 'Permintaan penarikan sudah dalam proses',
  WalletDoesNotBelongToUser: 'Dompet ini bukan milik pengguna ini',
  BetAlreadyInProgress: 'Taruhan sudah dalam proses',
  ServerSeedNotFoundErrorType: 'Server seed tidak ditemukan, silakan masuk kembali',
  InvalidMineCountErrorType: 'Jumlah ranjau harus dalam rentang 1 hingga 24',
  InvalidTileErrorType: 'Ubin harus dalam rentang 1 hingga 25',
  MineTileAlreadyOpenedErrorType: 'Pilih ubin lain',
  NoOpenedTileFoundErrorType: 'Tidak ada ubin terbuka ditemukan untuk taruhan ini',
  MineGamePreviousRoundNotCompletedErrorType: 'Ronde sebelumnya permainan Mine belum selesai',
  FavoriteGameExistsErrorType: 'Permainan Favorit sudah ada',
  FavoriteGameNotFoundErrorType: 'Permainan Favorit tidak ditemukan',
  TransactionAlreadyPendingErrorType: 'Transaksi sudah dalam proses',
  UserHasNoActiveBonusErrorType: 'Pengguna tidak memiliki bonus aktif',
  BonusExpiredErrorType: 'Bonus telah kedaluwarsa',
  UserHasAlreadyActivatedBonusWageringErrorType: 'Pengguna sudah mengaktifkan wagering bonus',
  InvalidRoundHashErrorType: 'Round Hash Salah',
  InvalidSignatureErrorType: 'Tanda Tangan Salah',
  UserHasNoBonusAmountToClaimErrorType: 'Pengguna tidak memiliki jumlah bonus untuk diklaim',
  BonusNotExistsErrorType: 'Bonus tidak ditemukan',
  PokerGameJoinTableErrorType: 'Kesalahan saat bergabung ke meja',
  PokerGameLeaveTableErrorType: 'Kesalahan saat meninggalkan turnamen',
  PokerGameRoundNotRunningErrorType: 'Ronde tidak sedang berjalan',
  PokerGamePlayerNotSeatedErrorType: 'Pemain belum duduk',
  PokerGameRoundHandDetailsErrorType: 'Detail hand ronde tidak ditemukan',
  PokerGameBetRangeErrorType: 'Taruhan yang dipasang tidak memenuhi syarat taruhan minimum',
  PokerGamePlaceBetErrorType: 'Kesalahan saat memasang taruhan',
  PokerGamePlayerAlreadySeatedErrorType: 'Pemain sudah duduk',
  BlockedTransactionErrorType: 'Kesalahan pemblokiran transaksi',
  PokerGameBuyInRangeErrorType: 'Rentang buy-in tidak memenuhi syarat rentang buy-in minimum dan maksimum',
  PokerGameSeatNotAvailableFoundErrorType: 'Kursi tidak tersedia',
  PokerGameTakeSeatErrorType: 'Kesalahan saat mengambil kursi',
  PokerGameGetTablesErrorType: 'Kesalahan saat mengambil meja permainan poker',
  PokerGameSeatNotFoundErrorType: 'Kesalahan saat mengambil kursi meja permainan poker',
  PokerGameTableNotFoundErrorType: 'Kesalahan saat mengambil meja permainan poker',
  PokerGameCalculateSidePotErrorType: 'Kesalahan saat menghitung side pot',
  PokerGameHandleBetErrorType: 'Kesalahan saat menangani taruhan',
  PokerGameHandleCallErrorType: 'Kesalahan saat menangani call',
  PokerGameHandleCheckErrorType: 'Kesalahan saat menangani check',
  PokerGameHandleFoldErrorType: 'Kesalahan saat menangani fold',
  PokerGameHandleRaiseErrorType: 'Kesalahan saat menangani raise',
  PokerGameStackRaiseAmountCannotBeLessThenZeroErrorType: 'Kesalahan saat menangani raise ketika jumlah raise kurang dari 0',
  PokerGameStackAmountLessThenRaiseAmountErrorType: 'Kesalahan saat menangani raise ketika jumlah stack kurang dari jumlah raise',
  CANNOT_CASHOUT_WITHOUT_FROG_START: 'Tidak dapat melakukan cash out tanpa Frog Start',
  BET_AMOUNT_MUST_BE_GREATER_THAN_0: 'Jumlah taruhan harus lebih besar dari 0',
  NO_BALANCE: 'Saldo Tidak Cukup',
  CASH_OUT_FAILED: 'Pencairan dana gagal',
}

// NOTE: PLEASE ADD YOUR OTHER KEY TRANSLATIONS HERE ONLY
const otherTranslationKeys = {
  betAmount: 'Jumlah Taruhan',
  betHistory: 'Riwayat Taruhan',
  provablyFair: 'Provably Fair',
  minimumBet: 'Taruhan minimum',
  maximumBet: 'Taruhan maksimum',
  selectYourBetAmount: 'Pilih jumlah taruhan Anda',
  buyInAmount: 'Jumlah BuyIn',
  selectYourBuyInAmountFromGivenRange: 'Pilih Jumlah BuyIn Anda dari rentang yang diberikan',
  profitOnWin: 'Keuntungan saat Menang',
  payoutOnWin: 'Pembayaran saat Menang',
  profitOnSingleWin: 'Keuntungan per Kemenangan',
  payoutOnSingleWin: 'Pembayaran saat Menang Tunggal',
  noOfBets: 'Jumlah taruhan',
  auto: 'Otomatis',
  half: '½',
  double: '2x',
  start: 'Mulai',
  cancel: 'Batal',
  prediction: 'Prediksi',
  luckyNumber: 'Angka Keberuntungan',
  multiplier: 'Pengali',
  chanceToWin: 'Peluang menang',
  betBtn: 'Pasang Taruhan',
  bets: 'Taruhan',
  depositBtn: 'Setor',
  rollOver: 'Roll Over',
  rollUnder: 'Roll Under',
  invalidBetAmount: 'Jumlah taruhan tidak valid',
  maxBetAmountLimit: 'Batas jumlah taruhan maksimum {{value}} terlampaui',
  minBetAmountLimit: 'Jumlah taruhan minimum adalah {{value}}.',
  noBalance: 'Jumlah taruhan lebih besar dari saldo dompet',
  noAutoCashout: 'Rate otomatis wajib diisi.',
  autoRateLimitWarning: 'Rate otomatis harus lebih besar dari {{value}}',
  potentialWin: 'Potensi Menang',
  gameMode: 'Mode permainan',
  changeSeeds: 'Ubah Seed',
  betAmt: 'Total Jumlah Taruhan',
  chipValue: 'Nilai Chip: 1 chip = 0,01',
  undo: 'Batalkan',
  clear: 'Hapus',
  changeSeedModal: {
    heading: 'Ubah Seed',
    description: 'Server seed dan client seed adalah dua bahan yang menghasilkan hasil permainan ini. Keduanya berubah setelah setiap taruhan. Hash server seed adalah hash SHA256 dari server seed ronde berikutnya.',
    clientSeed: {
      label: 'Client Seed'
    },
    serverSeedHash: {
      label: 'Hash Server Seed'
    },
    loading: 'Memuat ...',
    alphanumeric: {
      message: 'Masukkan string alfanumerik client seed yang valid'
    },
    editClientSeed: {
      label: 'Edit Client Seed'
    },
    save: {
      label: 'Simpan'
    }
  },
  betCancelledSuccessfully: 'Taruhan berhasil dibatalkan',
  maxAmountWarning: 'Jumlah taruhan tidak boleh lebih besar dari ',
  minAmountWarning: 'Jumlah taruhan tidak boleh lebih kecil dari ',
  noAmountWarning: 'Silakan periksa jumlah taruhan Anda',
  inSufficientBalanceWarning: 'Saldo tidak cukup.',
  placeBetWarning: 'Silakan masuk untuk memasang taruhan.',
  autoRateWarning: 'Rate otomatis harus lebih besar dari atau sama dengan',
  autoRateWarningMaxOdds: 'Rate otomatis harus lebih kecil dari atau sama dengan',
  limit: 'batas terlampaui.',
  notAchieved: 'tidak tercapai.',
  maxBetAmount: 'Jumlah taruhan maksimum',
  minBetAmount: 'Jumlah taruhan minimum',
  messages: {
    maxBetAmount: 'Jumlah taruhan maksimum',
    limit: 'batas terlampaui.',
    minBetAmount: 'Jumlah taruhan minimum',
    notAchieved: 'tidak tercapai.',
    zeroError: 'Nomor taruhan harus lebih dari 0',
    inSufficientBalanceWarning: 'Saldo tidak cukup.',
    noBalance: 'Saldo tidak cukup.'
  },

  // EXA GAMING TRANSLATIONS
  STATS: 'Statistik',
  ALL: 'Semua',
  TOP: 'Teratas',
  HISTORY: 'Riwayat',
  BET: 'Taruhan',
  NO_PLACED_BETS: 'Tidak ada taruhan yang dipasang.',
  NO_DATA: 'Tidak ada data tersedia.',
  BET_HISTORY: 'Riwayat Taruhan',
  LOAD_MORE: 'Muat Lebih Banyak',
  AUTO_BET: 'Taruhan Otomatis',
  BET_TYPE: 'Jenis Taruhan',
  BET_AMOUNT: 'Jumlah Taruhan',
  AUTO_CASHOUT: 'Cashout Otomatis',
  CASHOUT_AT: 'Cashout Pada',
  ADD: 'Tambah',
  MULTIPLY: 'Kalikan',
  CANCEL: 'Batal',
  CASH_OUT: 'CASH OUT',
  CANCEL_AUTO_BET: 'Batalkan Taruhan Otomatis',
  START_AUTOBET: 'Mulai Taruhan Otomatis',
  CANCEL_AUTOBET: 'Batalkan Taruhan Otomatis',
  NOT_BALANCE: 'Saldo tidak cukup.',
  MAX_BET_ERR: 'Jumlah taruhan maksimum',
  LIMIT_ERR: 'batas terlampaui.',
  MIN_BET_ERR: 'Jumlah taruhan minimum',
  NOT_ARCHIEVED: 'tidak tercapai.',
  MAX_LIMIT_ERR: 'Kesalahan batas taruhan maksimum',
  MIN_LIMIT_ERR: 'Kesalahan batas taruhan minimum',
  AUTO_RATE_ERR: 'Rate otomatis harus lebih besar dari atau sama dengan',
  AUTO_RATE_WARNING: 'Rate otomatis harus lebih kecil dari atau sama dengan',
  MIN_AUTO_ERR: 'Kesalahan Rate Otomatis Minimum',
  MAX_AUTO_ERR: 'Kesalahan Rate Otomatis Maksimum',
  NO_AUTO_CASHOUT: 'Silakan berikan jumlah Cashout Otomatis',
  NO_CASHOUT: 'Tidak Ada Cashout Otomatis',
  CHAT: 'Obrolan',
  SETTINGS: 'Pengaturan',
  LANGUAGE: 'Bahasa',
  VOLUME: 'Volume',
  MUTE: 'Bisukan',
  HOW_TO_PLAY: 'CARA BERMAIN',
  DISABLE: 'Nonaktifkan',
  CHAT_DISABLED: 'Obrolan Dinonaktifkan',
  TURN_CHAT: 'Aktifkan Obrolan',
  TO_DISCUSS: 'untuk berdiskusi.',
  SEND_MESSAGE: 'Kirim Pesan',
  INVALID_INPUT_MESSAGE: 'Pesan input tidak valid.',
  TEXT_COPY: 'Teks Disalin!',
  COPIED: 'Disalin',
  INFO: 'Info',
  MULTIPLIER: 'Pengali',
  ROUND_ID: 'ID Ronde',
  ROUND_HASH: 'Hash Ronde',
  ROUND_SIGNATURE: 'Tanda Tangan Ronde',
  GAME_LIMIT: 'Batas Permainan',
  GOLD_COIN: 'Koin Emas',
  MINIMUM_BET: 'Taruhan Minimum',
  MAXIMUM_BET: 'Taruhan Maksimum',
  MAX_WIN: 'Kemenangan maksimum untuk satu taruhan',
  SWEEPSTAKE_COIN: 'Koin Sweepstakes',
  HOW_PLAY: 'Cara Bermain',
  HOW_PLAY_AZTECMAN: 'AztecMan adalah permainan baru dari GS-Custom! Anda bisa menang berkali-kali lipat dengan permainan crash yang inovatif untuk bersenang-senang! AztecMan dibangun di atas sistem provably fair. Selamat Bersenang-senang!',
  HOW_PLAY_FOLLOW_ARROW: 'Follow The Arrow adalah permainan baru dari Exa-Gaming! Anda bisa menang berkali-kali lipat dengan permainan crash yang inovatif untuk bersenang-senang! Follow The Arrow dibangun di atas sistem provably fair. Selamat Bersenang-senang!',
  HOW_PLAY_POWER_THOR: 'Power Of Thor adalah permainan baru dari Exa-Gaming! Anda bisa menang berkali-kali lipat dengan permainan crash yang inovatif untuk bersenang-senang! Power Of Thor dibangun di atas sistem provably fair. Selamat Bersenang-senang!',
  HOW_PLAY_DRACARYS: 'Dracarys adalah permainan baru dari Exa-Gaming! Anda bisa menang berkali-kali lipat dengan permainan crash yang inovatif untuk bersenang-senang! Dracarys dibangun di atas sistem provably fair. Selamat Bersenang-senang!',
  HOW_PLAY_HAPPY_BIRD: 'Happy Bird adalah permainan baru dari Exa-Gaming! Anda bisa menang berkali-kali lipat dengan permainan crash yang inovatif untuk bersenang-senang! Happy Bird dibangun di atas sistem provably fair. Selamat Bersenang-senang!',
  HOW_PLAY_TOP_INFO: '{{gameName}} adalah permainan baru dari GS-Custom! Anda bisa menang berkali-kali lipat dengan permainan crash yang inovatif untuk bersenang-senang! {{gameName}} dibangun di atas sistem provably fair. Selamat Bersenang-senang!',
  GAME_DETAIL: 'Detail Permainan',
  HOW_PLAY_ONE: 'Pengali kemenangan dimulai dari 1x dan terus bertambah besar seiring Karakter lepas landas.',
  HOW_PLAY_TWO: 'Kemenangan Anda dihitung pada pengali saat Anda melakukan Cash Out, dikalikan dengan taruhan Anda.',
  HOW_PLAY_THREE: 'Sebelum awal setiap ronde, generator angka acak provably fair kami menghasilkan pengali di mana Karakter akan crash. Anda bisa mendapatkan ID Ronde, Hash Ronde, dan Tanda Tangan Ronde, di tab Info',
  BET_CASHOUT: 'Taruhan & Cashout',
  HOW_PLAY_FOUR: 'Anda bisa memasang beberapa taruhan sekaligus, dengan menggunakan dua panel taruhan yang berbeda.',
  HOW_PLAY_FIVE: 'Tekan tombol “Cash Out” untuk mencairkan kemenangan Anda. Kemenangan Anda adalah taruhan Anda dikalikan dengan pengali Cash Out.',
  HOW_PLAY_SIX: 'Taruhan Anda hilang, jika Anda tidak melakukan cash out sebelum karakter terbang menjauh.',
  AUTO_PLAY_CASHOUT: 'Auto Play & Auto Cash Out',
  HOW_PLAY_SEVEN: 'Auto Play diaktifkan dengan menyalakan sakelar “Taruhan Otomatis” pada panel taruhan.',
  HOW_PLAY_EIGHT: 'Auto Cash Out tersedia dengan menyalakan sakelar “Cashout Otomatis” pada panel Taruhan. Setelah diaktifkan, taruhan Anda akan otomatis di-cash out saat mencapai pengali yang dimasukkan',
  LIVE_BETS_STATISTIC: 'Taruhan Langsung & Statistik',
  HOW_PLAY_NINE: 'Di sisi kanan antarmuka permainan (atau di bawah Panel Taruhan pada perangkat seluler), terletak panel Taruhan Langsung. Di sini Anda dapat melihat semua taruhan yang sedang dibuat pada ronde saat ini.',
  HOW_PLAY_TEN: 'Di panel “Riwayat” Anda dapat melihat semua taruhan Anda dan informasi Cash Out.',
  HOW_PLAY_ELE: 'Di panel “Teratas”, statistik permainan terletak. Anda bisa menelusuri kemenangan berdasarkan jumlah, atau pengali Cash Out, dan melihat pengali ronde terbesar.',
  OTHER: 'Lainnya',
  HOW_PLAY_TWE: 'Jika koneksi internet terputus saat taruhan aktif, permainan akan otomatis melakukan cash out dengan pengali saat ini, dan jumlah kemenangan akan ditambahkan ke saldo Anda.',
  HOW_PLAY_THIRT: 'Dalam hal terjadi kerusakan pada perangkat keras/perangkat lunak permainan, semua taruhan dan pembayaran permainan yang terpengaruh menjadi batal dan semua taruhan yang terpengaruh dikembalikan.',
  NEXT_ROUND: 'Ronde Berikutnya',
  ROUND_HASH_ERR: 'Hash Ronde Diperlukan',
  SIGNATURE_ERR: 'Tanda Tangan Diperlukan',
  CHECK_PROVABLY: 'Periksa Provably Fair',
  PROVABLY_DESCRIPTION: 'Permainan ini menggunakan teknologi Provably Fair untuk menentukan hasil permainan. Alat ini memberi Anda kemampuan untuk mengubah seed Anda dan memeriksa keadilan permainan.',
  CRASH_RATE: 'Rate Crash',
  SIGNATURE: 'Tanda Tangan',
  LOADING: 'Memuat',
  VERIFY_GAME: 'Verifikasi Permainan',
  VERIFY_DESCRIPTION: 'Anda dapat memeriksa keadilan setiap ronde dari riwayat ronde.',
  YOU_WIN: 'Anda menang',
  PLAY_AGAIN: 'MAIN LAGI',
  GENERAL_INFO: 'Info',
  HISTORY_ROUNDS: 'Riwayat ronde',
  PRIMARY_BET: 'Taruhan Utama',
  SECONDARY_BET: 'Taruhan Sekunder',
  GENERAL_STATS: 'Statistik',
  GENERAL_PLAY: 'Main',
  GENERAL_MESSAGES: 'Pesan',
  CHOOSE_VESSEL: 'Pilih Kendaraan Anda!',
  GENERAL_DESC: 'Pilih Karakter yang Ingin Membawa Anda ke Bulan! ',
  ROCKET_FISH: 'Rocket Fish',
  ROCKET_BOY: 'Rocket Boy',
  HAPPY_KITEN: 'Happy Kitten',
  START_PLAYING: 'Mulai Bermain!',
  TempleGold: 'Temple Gold',
  DRACARYS: 'Dracarys',
  FOLLOW_THE_ARROW: 'Follow The Arrow',
  HAPPY_BIRD: 'Happy Bird',
  POWER_OF_THOR: 'Power Of Thor',
  STAR_CATCHER: 'Star Catcher',
  TYPE_HERE: 'Ketik di sini',
  WIN: 'Menang',
  LOSE: 'Kalah',
  PENDING: 'Tertunda',
  WAITING_FOR_NEXT_ROUND: 'Tunggu Ronde Berikutnya',
  LOGIN_SUCCESS: 'Berhasil Masuk',
  GAME_CLOSED_SUCCESS: ' Permainan Berhasil Ditutup',
  BET_PLACED_SUCCESS: 'Taruhan Berhasil Dipasang!',
  CANCEL_PLACED_SUCCESSFULLY: 'Pembatalan berhasil dilakukan',
  PLACE_BET_FAILED: 'Gagal Memasang Taruhan',
  PLAYER_ESCAPED_SUCCESS: 'Pemain Berhasil Melarikan Diri',
  BET_CANCEL_SUCCESS: 'Taruhan Berhasil Dibatalkan',
  INTERNAL_SERVER_ERROR: 'Kesalahan Server Internal',
  UNAUTHORIZED: 'Tidak Diizinkan',
  GAME_NOT_AVAILABLE: 'Permainan {{gameName}} tidak Tersedia',
  CONTACT_PROVIDER: 'Silakan Hubungi operator',
  THIS_GAME: 'Ini',
  TODO_ROCKET: 'TODO Rocket',
  PAGE_NOT_FOUND: 'Halaman Tidak Ditemukan',
  SOMETHING_WENT_WRONG: 'Terjadi kesalahan!',
  BALANCE: 'Saldo',
  HIT: 'Hit',
  STAND: 'Stand',
  SPLIT: 'Split',
  DOUBLE: 'Double',
  INSURANCE: 'Asuransi',
  ACCEPT_INSURANCE: 'Terima Asuransi',
  NO_INSURANCE: 'Tanpa Asuransi',
  PLACE_BET: 'Pasang Taruhan',
  SPLIT_BET: 'Taruhan Split',
  FAIRNESS: 'Keadilan',
  BET_AMOUNT_ERROR: 'Jumlah Taruhan tidak dalam batas',
  INSUFFICIENT_ERROR: 'Saldo tidak cukup untuk memasang taruhan',
  INVALID_BET_AMT_ERROR: 'Jumlah Taruhan Tidak Valid',
  COPY_ERR: 'Salin tidak didukung.',
  COPPIED: 'Disalin',
  SEEDS: 'Seed',
  VERIFY: 'Verifikasi',
  BET_CLIENT_SEED: 'Client Seed Taruhan Terakhir',
  BET_SERVER_SEED: 'Server Seed Taruhan Terakhir',
  NEXT_CLIENT_SEED: 'Client Seed Berikutnya',
  ROTATE_SEED: 'Rotasi Pasangan Seed',
  LAST_BET_RISK: 'Tingkat Risiko Taruhan Terakhir',
  GENERATE_NEW_CLIENT_SEED: 'Buat Client Seed Baru',
  LAST_BET_ROWS: 'Baris Taruhan Terakhir',
  GENERATE: 'Buat',
  DIFFICULTY_TYPE: 'Jenis Tingkat Kesulitan',
  ENTER_ROUND_HASH: 'Masukkan Hash Putaran',
  NEW_SEED: 'Client Seed Baru',
  CHANGE: 'Ubah',
  NEXT_SEED: 'Server Seed Berikutnya (Di-hash)',
  DEALER_CARD: 'Kartu dealer',
  USER_CARD: 'Kartu pengguna',
  DECK_CARD: 'Kartu deck',
  CORRECT_INPUT_RESULT: 'Input yang benar diperlukan untuk memverifikasi hasil',
  GAME: 'Permainan',
  CLIENT_SEED: 'Client Seed',
  SERVER_SEED: 'Server Seed',
  ENTER_CLIENT_SEED: 'Masukkan Client Seed',
  ENTER_SERVER_SEED: 'Masukkan Server Seed',
  PLINKO_ROLE_ONE: 'Mode yang dikonfigurasi melalui risiko dan pengali menentukan potensi pembayaran yang berbeda.',
  PLINKO_ROLE_TWO: 'Tidak ada hack gravitasi dengan memutar perangkat atau monitor saat bermain.',
  OK: 'Oke',
  RULES: 'Aturan',
  ID: 'ID {{id}}',
  PLACE_DATE: 'Dipasang oleh Anda pada Tanggal',
  ROUND_RESULT: 'Hasil Ronde',
  PAYOUT: 'Pembayaran',
  RANK: 'Peringkat',
  USER: 'Pengguna',
  DATE: 'Tanggal',
  CASHOUT_ERROR: 'Tidak dapat cashout dengan nol ubin terbuka',
  MINE_BET_ERROR: 'Silakan berikan jumlah taruhan yang valid',
  TILE_ERROR: 'Silakan pilih beberapa ubin',
  NO_BALANCE: 'Tidak dapat bertaruh lebih dari saldo Anda',
  MAX_BET_AMOUNT_LIMIT: 'Anda telah melampaui batas taruhan maksimum {{value}}.',
  MIN_BET_AMOUNT_LIMIT: 'Taruhan Anda di bawah batas minimum {{value}}.',
  MIN_BET_AMOUNT_LIMIT_MIN_MAX_INFO: 'Jumlah taruhan Anda tidak boleh di bawah jumlah taruhan minimum {{value}}.',
  MAX_BET_AMOUNT_LIMIT_MIN_MAX_INFO: 'Jumlah taruhan Anda tidak boleh melebihi jumlah taruhan maksimum {{value}}.',
  NOT_ACHIEVED: 'Tidak Tercapai',
  MAX_BET_AMOUNT: 'Jumlah Taruhan Maksimum',
  MIN_BET_AMOUNT: 'Jumlah Taruhan Minimum',
  LIMIT: 'Batas',
  ROLLS_LIMIT_MSG: 'Pesan Batas Roll',
  MAX_ROLLS_LIMIT: 'Anda telah melampaui batas jumlah taruhan maksimum {{value}}.',
  TILE_OPEN: 'Semua ubin terbuka',
  MANUAL: 'Manual',
  AUTO: 'Otomatis',
  MAX: 'Maks',
  MINES: 'Ranjau',
  RISK_LEVEL: 'Tingkat Risiko',
  STARS_LEFT: 'Bintang tersisa',
  TOTAL_PROFIT: 'Total keuntungan',
  PICK_TILE: 'Pilih ubin acak',
  CASHOUT: 'Tarik Kemenangan',
  CASHOUT1: 'Tarik Kemenangan',
  NUM_OF_BETS: 'Jumlah Taruhan',
  ON_WIN: 'Saat Menang (%)',
  ON_LOSS: 'Saat Kalah (%)',
  STOP_PROFIT: 'Berhenti saat Untung',
  STOP_LOSS: 'Berhenti saat Rugi',
  CONFIGURE_AUTO: 'Konfigurasi Otomatis',
  STRATEGY_APPLY: 'Strategi diterapkan.',
  DATA_ERROR: 'Data yang dimasukkan tidak valid',
  INCREASE_BY: 'Tingkatkan sebesar',
  RESET: 'Atur Ulang',
  RESET_ALL: 'Atur Ulang Semua',
  APPLY: 'Terapkan',
  TILE_ERR: 'Tidak dapat memilih lebih banyak ubin',
  YOU: 'Anda',
  WON: 'MENANG!',
  LOST: 'KALAH!',
  BET_TOOLTIP: 'Jumlah taruhan Anda per bola adalah {{maxBetAmt}}.',
  MAX_PAYOUT: 'Pembayaran Maks:',
  YOUR_BET: 'Taruhan Anda',
  MIN: 'Min',
  TOTAL_BET: 'Total Jumlah Taruhan:',
  NUM_BALL: 'Jumlah Bola',
  ROWS: 'Baris',
  NUM_BET: 'Jumlah Taruhan',
  STOP_AUTOBET: 'Hentikan Taruhan Otomatis',
  TURBO: 'Turbo',
  LIVE_STATS: 'Statistik Langsung',
  PROFIT: 'Untung / Rugi',
  WINS: 'Jumlah Kemenangan',
  WAGERED: 'Dipertaruhkan',
  LOSS: 'Jumlah Kekalahan',
  HOTKEY: 'Tombol Pintas',
  RISKS: 'Risiko',
  RISK: 'Risiko',
  CLASSIC: 'Klasik',
  LOW: 'Rendah',
  MEDIUM: 'Sedang',
  HIGH: 'Tinggi',
  PLINKO_NUM_ERR: 'Tidak dapat mengubah jumlah baris saat permainan berjalan!',
  BET_AMOUNT_ERR: 'Silakan berikan jumlah Taruhan',
  BET_AMOUNT_PROVIDE_ERROR: 'Silakan berikan jumlah Taruhan yang valid',
  SPACE: 'Spasi',
  DOUBLE_BET: 'Gandakan Jumlah Taruhan',
  HALVE_BET: 'Setengahkan Jumlah Taruhan',
  DECREASE_ROW: 'Kurangi Jumlah Baris',
  INCREASE_ROW: 'Tambah Jumlah Baris',
  HOTKEY_ENABLED: 'Tombol Pintas Diaktifkan',
  HOTKEY_DESCRIPTION: 'Ketika tombol pintas diaktifkan, mereka akan tetap aktif untuk semua permainan hingga dinonaktifkan. Meskipun beberapa permainan memiliki key bind yang serupa, selalu disarankan untuk memastikan interaksi tombol apa yang diatur untuk setiap permainan.',
  ASSET_LOAD_ERROR: 'Aset Permainan Tidak Dimuat! Silakan muat ulang situs web',
  CHANGE_SEED: 'Ubah Seed',
  HALF: 'Setengah',
  BET_NUMBER: 'Nomor taruhan',
  START: 'Mulai',
  YOU_WON_AMT: 'Anda Menang {{currency}}{{amount}}',
  YOU_WON_AMT_AND_MULTI: 'Anda Menang {{currency}}{{amount}} ({{multiplier}}x)',
  YOU_LOST: 'Anda Kalah !',
  UNDO: 'Batalkan',
  CLEAR: 'Hapus',
  YOU_WON: 'ANDA MENANG',
  SEED_HEADING: 'Keadilan',
  SEED_CLIENT_LABEL: 'Client Seed',
  SEED_HASH_LABEL: 'Server Seed',
  SEED_LOADING: 'memuat...',
  SEED_ALPHA_MESSAGE: 'Seed harus berupa alfanumerik.',
  SEED_SAVE_LABEL: 'Simpan',
  SEED_EDIT_LABEL: 'Edit',
  SEED_DESCRIPTION: 'Seed',
  GENERATE_SEED: 'Buat Seed Baru',
  COLUMN_BET_SELECTION: 'Anda hanya dapat memilih {{maxValHoldCount}} taruhan Kolom.',
  DOZEN_BET_SELECTION: 'Anda hanya dapat memilih {{maxValHoldCount}} taruhan Lusin.',
  ODD_EVEN_BET_SELECTION: 'Anda hanya dapat memilih {{maxValHoldCount}} taruhan Genap atau Ganjil.',
  COLOR_BET_SELECTION: 'Anda hanya dapat memilih {{maxValHoldCount}} taruhan warna Merah atau Hitam.',
  LOW_HI_BET_SELECTION: 'Anda hanya dapat memilih {{maxValHoldCount}} taruhan Rendah-Tinggi',
  LAST_CRASH_RATE: 'Rate Crash Taruhan Terakhir',
  MINE_SPACE: 'Spasi',
  MINE_SPACE_RULE: 'Pasang Taruhan atau Cashout atau Batalkan Taruhan ( Taruhan Otomatis )',
  MINE_W: 'W',
  MINE_W_RULE: 'Gandakan Jumlah Taruhan',
  MINE_S: 'S',
  MINE_S_RULE: 'Setengahkan Jumlah Taruhan',
  MINE_A: 'A',
  MINE_A_RULE: 'Hapus Ranjau',
  MINE_D: 'D',
  MINE_D_RULE: 'Tambah Ranjau',
  MINE_Q: 'Q',
  MINE_Q_RULE: 'Pilih Ubin Acak',
  RESULT_CORRECT_INPUT: 'Input yang benar diperlukan untuk memverifikasi hasil',
  WIN_AMOUNT: 'Jumlah Kemenangan',
  DATE_TIME: 'Tanggal / Waktu',

  USER_DISCLAIMER: 'Penafian Pengguna',
  USER_DISCLAIMER_TEXT: 'Alat ini ditujukan untuk pemain berpengalaman yang ingin menjalankan strategi tingkat lanjut. Lanjutkan dengan risiko Anda sendiri.',
  DONT_SHOW_AGAIN: 'Jangan tampilkan lagi',
  I_UNDERSTAND: 'Saya Mengerti',
  ROLL_OVER: 'Lempar di Atas',
  ROLL_UNDER: 'Lempar di Bawah',
  ADVANCED: 'Lanjutan',
  WAGER: 'Taruhan',
  STRATEGY: 'Strategi',
  CREATE_STRATEGY: 'Buat Strategi',
  CONDITIONS: 'Kondisi',
  EDIT: 'Ubah',
  ADVANCED_BET_CONDITIONS:'Kondisi taruhan lanjutan akan dijalankan dari atas ke bawah',
  CONDITION: 'Kondisi',
  BET_CONDITION: 'Kondisi Taruhan',
  PROFIT_CONDITION: 'Kondisi Keuntungan',
  LABEL: 'Label',
  DELETE_CONDITION: 'Hapus Kondisi',
  DELETE_STRATEGY: 'Hapus Strategi',
  ADD_NEW_CONDITION: 'Tambah Kondisi Baru',
  ON: 'Saat',
  DO: 'Lakukan',
  EVERY: 'Setiap',
  EVERY_STREAK_OF: 'Setiap rangkaian',
  FIRST_STREAK_OF: 'Rangkaian pertama',
  STREAK_GREATER_THAN: 'Rangkaian lebih besar dari',
  STREAK_LOWER_THAN: 'Rangkaian lebih kecil dari',
  BETS: 'Taruhan',
  WINS: 'Kemenangan',
  LOSSES: 'Kekalahan',
  MAX : 'MAX',
  INCREASE_BET_AMOUNT_PERCENTAGE: 'Tingkatkan persentase jumlah taruhan',
  DECREASE_BET_AMOUNT: 'Kurangi jumlah taruhan',
  INCREASE_WIN_CHANCE: 'Tingkatkan peluang menang',
  DECREASE_WIN_CHANCE: 'Kurangi peluang menang',
  ADD_TO_BET_AMOUNT: 'Tambahkan ke jumlah taruhan',
  SUBTRACT_FROM_BET_AMOUNT: 'Kurangi dari jumlah taruhan',
  ADD_TO_WIN_CHANCE: 'Tambahkan ke peluang menang',
  SUBTRACT_FROM_WIN_CHANCE: 'Kurangi dari peluang menang',
  SET_BET_AMOUNT: 'Tetapkan jumlah taruhan',
  SET_WIN_CHANCE: 'Tetapkan peluang menang',
  SWITCH_OVER_UNDER: 'Ubah over/under',
  RESET_BET_AMOUNT: 'Atur ulang jumlah taruhan',
  RESET_WIN_CHANCE: 'Atur ulang peluang menang',
  GREATER_THAN: 'Lebih besar dari',
  GREATER_THAN_OR_EQUAL_TO: 'Lebih besar atau sama dengan',
  LOWER_THAN: 'Lebih kecil dari',
  LOWER_THAN_OR_EQUAL_TO: 'Lebih kecil atau sama dengan',
  STOP_ON_PROFIT: 'Berhenti saat untung',
  STOP_ON_LOSS: 'Berhenti saat rugi',
  RESET_ALL: 'Atur ulang semua',
  STRATEGY_NAME: 'Nama Strategi',
  STRATEGY_NAME_REQUIRED: 'Nama strategi wajib diisi',
  NAME_MIN_3_CHARACTERS: 'Nama harus terdiri dari minimal 3 karakter',
  STRATEGY_NAME_TOO_LONG: 'Nama strategi terlalu panjang',
  NAME_ALREADY_TAKEN: 'Nama sudah digunakan!',
  NAME: 'Nama',
  GET_STARTED: 'Mulai',
  AUTO_PICK: 'Pilih Otomatis',
  CLEAR_TABLE: 'Kosongkan Tabel',
  betConditionLabels: {
    every: 'Setiap',
    everyStreakOf: 'Setiap rentetan',
    firstStreakOf: 'Rentetan pertama',
    streakGreaterThan: 'Rentetan lebih besar dari',
    streakLowerThan: 'Rentetan lebih kecil dari',
    bet: 'Taruhan',
    win: 'Kemenangan',
    lose: 'Kekalahan',
    increaseByPercentage: 'Tingkatkan persentase jumlah taruhan',
    decreaseByPercentage: 'Kurangi jumlah taruhan',
    increaseWinChanceBy: 'Tingkatkan peluang menang',
    decreaseWinChanceBy: 'Kurangi peluang menang',
    addToAmount: 'Tambahkan ke jumlah taruhan',
    subtractFromAmount: 'Kurangkan dari jumlah taruhan',
    addToWinChance: 'Tambahkan ke peluang menang',
    subtractFromWinChance: 'Kurangkan dari peluang menang',
    setAmount: 'Atur jumlah taruhan',
    setWinChance: 'Atur peluang menang',
    switchOverUnder: 'Ganti lempar atas/bawah',
    resetAmount: 'Atur ulang jumlah taruhan',
    resetWinChance: 'Atur ulang peluang menang',
    stop: 'Hentikan taruhan otomatis',
    loss: 'Kerugian',
    balance: 'Saldo',
    profit: 'Keuntungan',
    greaterThan: 'Lebih besar dari',
    greaterThanOrEqualTo: 'Lebih besar dari atau sama dengan',
    lowerThan: 'Lebih kecil dari',
    lowerThanOrEqualTo: 'Lebih kecil dari atau sama dengan'
  },
  WIN_CHANCE: 'Peluang Menang',
  DIFFICULTY: 'Tingkat Kesulitan',
  GAME_SPEED: 'Kecepatan Permainan',
  GAME_MODE: 'Mode Permainan',
  LIVE_BETS: 'Taruhan Langsung',
  GAME_SETTINGS: 'Pengaturan Permainan',
  MAXIMUM_AUTO_BET_ONE_TIME: 'Maksimum taruhan otomatis dalam satu kali adalah 100 bola',
  LINES: 'Garis',
  EASY: 'Mudah',
  CRAZY: 'Gila',
  NORMAL: 'Normal',
  HARD: 'Sulit',
  CLOSE: 'Tutup',
  FAST: 'Cepat',
  HASH: 'Hash',
  BET: 'Taruhan',
  SKIP_CARD: 'Lewati Kartu',
  KING_BEING_THE_HIGHEST: 'KING sebagai kartu tertinggi',
  ACE_BEING_THE_LOWEST: 'ACE sebagai kartu terendah',
  PROFIT_HIGHER: 'Keuntungan Lebih Tinggi',
  PROFIT_LOWER: 'Keuntungan Lebih Rendah',
  TOTAL_PROFIT: 'Total Keuntungan',
  START_CARD: 'Kartu Awal',
  START_GAME: 'Mulai Permainan',
  ALL_BETS: 'Semua Taruhan',
  BIG_WINNERS: 'Pemenang Terbesar',
  COINS_AMOUNT: 'Jumlah Koin',
  PICK_SIDE: 'Pilih Sisi',
  POTENTIAL_WIN: 'Potensi Kemenangan',
  FLIP_COIN: 'Lempar Koin',
  EXIT: 'Keluar',
  EXTREME: 'Ekstrem',
  NIGHTMARE: 'Mimpi Buruk',
  ADVANCE_MODE_RULES: 'Aturan Mode Lanjutan',
  TOWER_ADVANCE_MODE_RULES_1: 'Baris 3/6/9 dapat muncul dengan',
  TOWER_ADVANCE_MODE_RULES_2: 'pengali akan muncul secara acak dan total pembayaran akan dikalikan dengan pengali yang sesuai.',
  SAME: 'Sama',
  HIGHER_SAME: 'Lebih Tinggi / Sama',
  LOWER_SAME: 'Lebih Rendah / Sama',
  CANCEL_BET: 'Batalkan Taruhan',
  OTHER_SETTINGS: 'Pengaturan Lainnya',
  TRY_AGAIN: 'Coba Lagi',
  PLAYERS: 'Pemain',
  NO_PARTICIPANTS: 'Tidak Ada Peserta',
  NETWORK_STATUS: 'Status Jaringan',
  NEXT_ROUND_IN: 'Putaran Berikutnya Dalam',
  CRASH_HISTORY: 'Riwayat Crash',
  TIME: 'Waktu',
  PREV: 'Sebelumnya',
  NEXT: 'Berikutnya',
  CASHOUT_AT_RATE : 'TARIK TUNAI DI {{rate}}x',
  PLAYERS_CASHED_OUT: 'pemain telah melakukan Tarik Kemenangan ',
  CASHED_OUT_AT: 'Ditarik Tunai Di ',
  CONNECTION_LOST: 'Koneksi Terputus',
  PLEASE_CHECK_YOUR_INTERNET_AND_TRY_AGAIN: 'Silakan periksa koneksi internet Anda dan coba lagi.',
  SELECT_1_10_NUMBERS_TO_PLAY: 'Pilih 1 - 10 angka untuk dimainkan',
  LOSS1: 'KALAH',
  PLEASE_SELECT_AT_LEAST_ONE_NUMBER: 'Silakan pilih setidaknya satu angka',
  RELOAD: 'Muat Ulang',

  CASHOUT_SUCCESSFUL: 'Cash Out berhasil',
}

/**
 * NOTE:
 * =================================================================================================
 * Please go through this spreading objects first before adding new translation key. So that the
 * duplicate translations will not be created and help us to maintain the consitency of code.
 * If you didn't find any of translation as per your requirement in reserve or api success & error
 * msg translation object, Please add new translation with unique key name in otherTranslationKeys
 * Object. Unique key names help us to avoid overriding of translations.
 * =================================================================================================
 */
export default {
  ...reservedTranslationsWithUniqueKeyNames,
  ...apiSuccessMessagesTranslations,
  ...apiErrorMessagesTranslations,
  ...otherTranslationKeys
}
